import { IImage } from "@faire/web-api/indigofair/data/IImage";
import { TransparencyOverlay } from "@faire/web/ui/TransparencyOverlay";
import { observer } from "mobx-react";
import React, { useCallback } from "react";

import {
  ImageCarousel,
  INamedImage,
} from "@faire/retailer/components/ImageCarousel/ImageCarousel";
import { TrackedLink } from "@faire/retailer/components/TrackedLink";
import { PAGE_TYPE } from "@faire/retailer/consts/PAGE_TYPE";

interface IPropTypes {
  token?: string;
  name?: string;
  images: INamedImage[];
  linkLocation?: string;
  eventPath?: string;
  onLinkClick?: () => void;
  title?: string | undefined;
  pageType?: PAGE_TYPE;
  useLazyImageLoading?: boolean;
  // This value will be empty if `NEW_BRAND_TILE_240312` is false.
  brandProductImages?: Array<IImage>;
}

const BrandTileImageSectionBase: React.FC<IPropTypes> = ({
  title,
  pageType,
  images,
  onLinkClick,
  linkLocation,
  token,
  name,
  useLazyImageLoading,
}) => {
  const imageWrapper = useCallback(
    (p: object) => (
      <TrackedLink
        {...p}
        token={token}
        onClick={() => {
          onLinkClick?.();
        }}
        to={linkLocation}
      />
    ),
    [token, onLinkClick, linkLocation]
  );

  return (
    <ImageCarousel
      title={title}
      pageType={pageType}
      images={images}
      ImageWrapper={imageWrapper}
      name={name ?? ""}
      hideDotsWhenSingleImage
      useLazyImageLoading={useLazyImageLoading}
      otelSpanName="BrandTileImage"
    >
      <TransparencyOverlay />
    </ImageCarousel>
  );
};

export const BrandTileImageSection = observer(BrandTileImageSectionBase);
